import { FC } from 'react';
import { GroupedCheckListDropdownMenu, useOptionsProvider } from '@frontend/call-intel-core';
import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { trackingIds } from '../../../../tracking-ids';
import { useVoiceAiLocations } from '../../hooks/use-voice-ai-locations';
import { useCallIntelFiltersContext } from '../context/call-intel-filters.context';
import { FilterTraySection } from './filter-tray-section/filter-tray-section';

export const AiOutcomeFilterTray: FC<{ showClear?: boolean; disabled?: boolean }> = ({
  disabled,
  showClear = true,
}) => {
  const { t } = useTranslation('call-intelligence');
  const { filterValues, updateFilterValues } = useCallIntelFiltersContext();
  const { getOptions } = useOptionsProvider();
  const { activeLocationIds: activeVoiceAiLocations, isLoading } = useVoiceAiLocations({
    locationIds: filterValues.locations ?? [],
  });

  const isDisabled = disabled || isLoading;

  if (!activeVoiceAiLocations.length) {
    return null;
  }

  return (
    <FilterTraySection
      label={t('AI Call Outcome')}
      showClear={showClear}
      disableClear={isDisabled}
      onClear={() => updateFilterValues({ aiOutcomes: [] })}
      icon={<Icon name='aiweave-assistant' size={16} opacity='0.75' />}
    >
      <GroupedCheckListDropdownMenu
        name='aiOutcomes'
        placeholder={t('Select AI Call Outcome')}
        groups={getOptions('aiCallOutcome', 'groupedArray')}
        label={t('Select AI Call Outcome')}
        onChange={(value) => updateFilterValues({ aiOutcomes: value })}
        value={filterValues.aiOutcomes}
        trackingIdBase={trackingIds.callIntel.aiOutcomeFilter}
      />
    </FilterTraySection>
  );
};
